<div class="padding5">
    <ion-input mode="md" presentation="date-time" type="datetime-local" *ngIf="withTime==1" [label]="label"
        labelPlacement="floating" [min]="minDate" [max]="maxDate" [placeholder]="label" (ionChange)="onChangeDate()"
        [(ngModel)]="modelString" fill='outline'></ion-input>
    <ion-input mode="md" presentation="date" [preferWheel]="true" type="date" *ngIf="withTime==0" [label]="label"
        labelPlacement="floating" [min]="minDate" [max]="maxDate" [placeholder]="label" (ionChange)="onChangeDate()"
        [(ngModel)]="modelString" fill='outline'></ion-input>
    <ion-input mode="md" presentation="time" type="time" *ngIf="withTime==-1" [label]="label" labelPlacement="floating"
        [min]="minDate" [max]="maxDate" [placeholder]="label" (ionChange)="onChangeDate()" [(ngModel)]="modelString"
        fill='outline'></ion-input>
</div>